export default __webpack_public_path__ + "static/media/background-image_authentication-page.12b79ab9.png";